import React from 'react';
import { Plus, Filter, RefreshCw, Eraser, AlertCircle, Clock, CheckCircle2 } from 'lucide-react';
import { TipoContaId } from '../../types/financeiro';
import { ProtectedField } from '../common/ProtectedField';

interface FinanceiroToolbarProps {
  statusFilter: string;
  onStatusChange: (status: string) => void;
  onRefresh: () => void;
  onClearFilters: () => void;
  onCreatePagar: () => void;
  onCreateReceber: () => void;
  loading?: boolean;
}

export function FinanceiroToolbar({
  statusFilter,
  onStatusChange,
  onRefresh,
  onClearFilters,
  onCreatePagar,
  onCreateReceber,
  loading = false,
}: FinanceiroToolbarProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 bg-white p-3.5 rounded-2xl border border-slate-200 shadow-2xs">
      {/* Botões Rápidos de Status */}
      <div className="flex flex-wrap items-center gap-2">
        <button
          type="button"
          onClick={() => onStatusChange('all')}
          className={`flex items-center gap-1.5 px-3.5 py-1.5 text-xs font-bold border rounded-xl transition-all cursor-pointer ${
            statusFilter === 'all'
              ? 'bg-slate-900 border-slate-900 text-white shadow-2xs'
              : 'text-slate-700 hover:bg-slate-50 border-slate-200'
          }`}
        >
          <Filter className="w-3.5 h-3.5" />
          Todos
        </button>

        <button
          type="button"
          onClick={() => onStatusChange(statusFilter === 'atrasadas' ? 'all' : 'atrasadas')}
          className={`flex items-center gap-1.5 px-3.5 py-1.5 text-xs font-bold border rounded-xl transition-all cursor-pointer ${
            statusFilter === 'atrasadas'
              ? 'bg-rose-600 border-rose-600 text-white shadow-2xs'
              : 'text-rose-700 hover:bg-rose-50 border-rose-200 bg-rose-50/50'
          }`}
        >
          <AlertCircle className="w-3.5 h-3.5" />
          Vencidas
        </button>

        <button
          type="button"
          onClick={() => onStatusChange(statusFilter === 'abertas' ? 'all' : 'abertas')}
          className={`flex items-center gap-1.5 px-3.5 py-1.5 text-xs font-bold border rounded-xl transition-all cursor-pointer ${
            statusFilter === 'abertas'
              ? 'bg-amber-500 border-amber-500 text-white shadow-2xs'
              : 'text-amber-800 hover:bg-amber-50 border-amber-200 bg-amber-50/50'
          }`}
        >
          <Clock className="w-3.5 h-3.5" />
          Em Aberto
        </button>

        <button
          type="button"
          onClick={() => onStatusChange(statusFilter === 'quitadas' ? 'all' : 'quitadas')}
          className={`flex items-center gap-1.5 px-3.5 py-1.5 text-xs font-bold border rounded-xl transition-all cursor-pointer ${
            statusFilter === 'quitadas'
              ? 'bg-emerald-600 border-emerald-600 text-white shadow-2xs'
              : 'text-emerald-800 hover:bg-emerald-50 border-emerald-200 bg-emerald-50/50'
          }`}
        >
          <CheckCircle2 className="w-3.5 h-3.5" />
          Quitadas / Pagas
        </button>

        <div className="h-6 w-px bg-slate-200 mx-1 hidden sm:block"></div>

        <button
          type="button"
          onClick={onRefresh}
          title="Recarregar Dados"
          className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold text-slate-700 hover:bg-slate-100 border border-slate-200 rounded-xl transition-colors cursor-pointer"
        >
          <RefreshCw className={`w-3.5 h-3.5 ${loading ? 'animate-spin' : ''}`} />
          Atualizar
        </button>

        <button
          type="button"
          onClick={onClearFilters}
          title="Limpar Filtros"
          className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold text-rose-600 hover:bg-rose-50 border border-rose-200 rounded-xl transition-colors cursor-pointer"
        >
          <Eraser className="w-3.5 h-3.5" />
          Limpar
        </button>
      </div>

      {/* Botões de Ação de Cadastro com Proteção de Permissão */}
      <div className="flex flex-wrap items-center gap-2">
        <ProtectedField permission="create_financial">
          <button
            type="button"
            onClick={onCreatePagar}
            className="inline-flex items-center justify-center rounded-xl border border-rose-200 bg-rose-50/80 px-3.5 py-1.5 text-xs font-bold text-rose-700 hover:bg-rose-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            <Plus className="-ml-1 mr-1.5 h-3.5 w-3.5" />
            Nova Conta a Pagar
          </button>
        </ProtectedField>
        
        <ProtectedField permission="create_financial">
          <button
            type="button"
            onClick={onCreateReceber}
            className="inline-flex items-center justify-center rounded-xl bg-emerald-600 px-3.5 py-1.5 text-xs font-bold text-white shadow-2xs hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            <Plus className="-ml-1 mr-1.5 h-3.5 w-3.5" />
            Nova Conta a Receber
          </button>
        </ProtectedField>
      </div>
    </div>
  );
}
